import { Progress } from '@mantine/core';

export function ProgressBar() {
  return <Progress w="100%" size="xs" value={100} animated />;
}
